import { createApi } from '@core/fetch'

export default {
  searchCustomerByPhone: createApi(
    '/p/wedding/Admin/APICrmMerchantCustomer/Search'
  ),
  // 创建客资
  createCustomer: createApi.post(
    '/p/wedding/Admin/APICrmMerchantCustomer/AutoCreate'
  ),
  // 创建客资并标记确认到店
  createCustomerThenMark: createApi.post(
    '/p/wedding/Admin/APICrmMerchantCustomer/AutoCreateAndMarkArrive'
  ),
  //日历任务列表
  getCalendarTask: createApi(
    '/p/wedding/index.php/admin/APICrmFranchiseeProgramme/ProgrammeList'
  ),
  //当前日期任务列表
  getDateTask: createApi(
    '/p/wedding/index.php/admin/APICrmFranchiseeProgramme/TaskList'
  ),
  // 日程提交完成信息
  submitFinishTask: createApi.post(
    '/p/wedding/index.php/admin/APICrmFranchiseeProgramme/AddTaskFinishedProgress'
  ),
  // 日程筛选
  getSupportList: createApi(
    '/p/wedding/index.php/admin/APICrmFranchiseeProgramme/MerchantSupportList'
  ),
  // 任务详情
  getTaskDetail: createApi(
    '/p/wedding/index.php/admin/APICrmFranchiseeProgramme/TaskDetail'
  ),
  // 数据
  getDataOverView: createApi(
    '/p/wedding/Admin/APIMerchantCustomer/DataOverView'
  )
}
